import React from "react";
import ser from "../../assets/used-icons/ser4.png";
import { useTranslation } from "react-i18next";
import { Calendar } from "lucide-react";
import { useUserData } from "../../store/UserData";

const ServiceList = () => {
  const { profile, loading, error } = useUserData();
  const { t } = useTranslation();

  if (loading) return (
    <div className="w-full grid gap-2">
      {
        [...Array(5)].map((_, i) => (
          <div key={i} className="flex gap-4 items-center bg-gray-100 p-2 rounded-md">
            <div className="size-16 rounded-full l-load-dt"></div>
            <div>
              <div className="w-40 h-3 rounded-full l-load-dt"></div>
              <div className="w-32 h-3 my-1 rounded-full l-load-dt"></div>
            </div>
          </div>
        ))
      }
    </div>
  );

  if (error) return (<p>{error || t('custom.err')}</p>)
  if (!profile) return (<p>{t('profile.no-data')}</p>)

  return (
    <div>
      {profile.serviceRegister && profile.serviceRegister.length > 0 ? (
        profile.serviceRegister.map((item, index) => (
          <div key={index} className="flex items-center justify-between bg-gray-100 rounded-xl p-4 px-6 mb-4">
            <div className="flex items-center justify-start gap-4 w-full md:w-5/12">
              <div className="flex items-center justify-center bg-white rounded-full w-[70px] h-[70px]">
                <img
                  src={ser}
                  alt={item.service.title}
                  className="w-12 h-10 object-contain"
                />
              </div>
              <div>
                <div className="text-lg font-medium text-red-900 !text-start">
                  {item.service.title}
                </div>
                <div className=" text-gray-500 mt-2.5 flex gap-1 items-center font-sans">
                  <Calendar fill="white" color="gray" size={18} />
                  <span>{item.created_at}</span>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>{t('profile.no-services')}</p>
      )}
    </div>
  );
};

export default ServiceList;
